module.exports = __webpack_public_path__ + "5d8cb6634cfdb88ae9c4a1784bae1666.svg";